
import {
    INIT_POINT_BALANCE_INFO,

    REQUEST_BIG_CARD_NUMBER_START,
    REQUEST_BIG_CARD_NUMBER_SUCCESS,
    REQUEST_BIG_CARD_NUMBER_FAIL,

    REQUEST_BIG_CARD_INFO_START,
    REQUEST_BIG_CARD_INFO_SUCCESS,
    REQUEST_BIG_CARD_INFO_FAIL,

    REQUEST_POINT_EXPIRE_START,
    REQUEST_POINT_EXPIRE_SUCCESS,
    REQUEST_POINT_EXPIRE_FAIL,

    REQUEST_POINT_BALANCE_START,
    REQUEST_POINT_BALANCE_SUCCESS,
    REQUEST_POINT_BALANCE_FAIL

} from '../actions/big-point';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

    const { type, data, payload, error } = action;

    switch (type) {

        case REQUEST_BIG_CARD_NUMBER_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_BIG_CARD_NUMBER_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_BIG_CARD_NUMBER_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_BIG_CARD_INFO_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_BIG_CARD_INFO_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_BIG_CARD_INFO_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_POINT_BALANCE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_POINT_BALANCE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_POINT_BALANCE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_POINT_EXPIRE_START:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.req, isLoading: true, type } }
            }

        case REQUEST_POINT_EXPIRE_SUCCESS:
            {
                // console.log(type, { state, action, payload })
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case REQUEST_POINT_EXPIRE_FAIL:
            {
                /*console.log(type, { state, action, payload })*/
                return { ...state, data: { ...payload.res, isLoading: false, type } }
            }

        case INIT_POINT_BALANCE_INFO:
            {
                return initialState;
            }

        default:
            {
                return { ...state };
            }
    }
};

export default reducer;
